import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStatusbarMouseWheel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 2.646 3.704",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-127.189 103.15)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 2.381,
			height: 3.44,
			x: 127.321,
			y: -103.017,
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 1.5,
			strokeWidth: .265,
			rx: .966,
			ry: .966
		}), /* @__PURE__ */ _jsx("rect", {
			width: .794,
			height: 1.323,
			x: 128.115,
			y: -102.621,
			fill: "currentColor",
			rx: .281,
			ry: .281
		})]
	})
});
export default SvgIconStatusbarMouseWheel;
